// extracted by mini-css-extract-plugin
module.exports = {"root":"BrandsPanel_root__ghFyE","panelItem":"BrandsPanel_panelItem__r4hx_","brandName":"BrandsPanel_brandName__8wu9L","letter":"BrandsPanel_letter__bth7f"};